import React, { useEffect, useState } from 'react';
import { Button, Modal, Box, Typography, Grid2, Card, Checkbox } from '@mui/material';
import ModalBox from '../../themes/overrides/ModalBox';
import { getAssets } from '../../actions/mediaAction';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';

const ExistingMediaUploadPopup = ({ open, onClose, onConfirm, workspaceId }) => {
    const dispatch = useDispatch();
    const [selectedAssets, setSelectedAssets] = useState([]);
    const assets = useSelector((state) => state.assets.assets);
    const theme = useTheme();

    useEffect(() => {
        if (open) {
            dispatch(getAssets(workspaceId));
        }
    }, [open, workspaceId, dispatch]);

    const handleAssetSelect = (asset) => {
        setSelectedAssets(prev => {
            const isSelected = prev.find(a => a._id === asset._id);
            if (isSelected) {
                return prev.filter(a => a._id !== asset._id);
            }
            return [...prev, asset]
        })
    }

    const handleConfirm = () => {
        onConfirm(selectedAssets);
        setSelectedAssets([]);
        onClose();
    }

    return (
        <div>
            <Modal open={open} onClose={onClose}>
                <ModalBox sx={{
                    width: { xs: '95%', sm: '600px', md: '700px' },
                    maxHeight: { xs: '95vh', sm: '90vh' }, padding: { xs: 2, md: 4 }
                }}>
                    <Typography variant="h6" component="h2">
                        Select Media Files
                    </Typography>
                    <Box sx={{ mt: 2, mb: 3 }}>
                        <Grid2 container spacing={2} rowGap={4}>
                            {assets.map((asset) => (
                                <Grid2 key={asset._id}>
                                    <Card
                                        elevation={2}
                                        sx={{
                                            position: 'relative',
                                            cursor: 'pointer',
                                            height: '100%',
                                            outline: selectedAssets.find(a => a._id === asset._id)
                                                ? '2px solid #7E5CAD'
                                                : 'none',
                                            border: '1px solid #eee',
                                            '&:hover': {
                                                outline: '2px solid rgba(0,109,112,0.5)'
                                            }
                                        }}
                                        onClick={() => handleAssetSelect(asset)}
                                    >
                                        <Box sx={{ width: '190px', height: '100px' }}
                                        >
                                            <img
                                                src={asset.url}
                                                alt={asset.title || 'Asset'}
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        </Box>

                                        <Checkbox
                                            checked={!!selectedAssets.find(a => a._id === asset._id)}
                                            sx={{
                                                position: 'absolute',
                                                top: 8,
                                                right: 8,
                                                borderRadius: '50%',
                                                border: 'none'
                                            }}
                                        />

                                    </Card>
                                    <Typography
                                        variant="subtitle1"
                                        noWrap
                                        sx={{
                                            color: '#2c3e50'
                                        }}
                                    >
                                        {asset.title || 'Untitled'}
                                    </Typography>
                                </Grid2>
                            ))}
                        </Grid2>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                        <Button onClick={onClose} sx={{ mr: 1 }}>
                            Cancel
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            variant="contained"
                            disabled={selectedAssets.length === 0}
                        >
                            Select ({selectedAssets.length})
                        </Button>
                    </Box>
                </ModalBox>
            </Modal>
        </div >
    );
};

ExistingMediaUploadPopup.propTypes = {
    open:PropTypes.bool,
    onClose:PropTypes.func, 
    onConfirm:PropTypes.any, 
    workspaceId:PropTypes.string
};

export default ExistingMediaUploadPopup;